import { render } from "./RedirectView.vue?vue&type=template&id=197538f6&scoped=true"
import script from "./RedirectView.vue?vue&type=script&lang=js"
export * from "./RedirectView.vue?vue&type=script&lang=js"

import "./RedirectView.vue?vue&type=style&index=0&id=197538f6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/lumaa.fr/lumaa.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197538f6"]])

export default __exports__